import { Mail, ArrowUpRight } from "lucide-react";
import { CONTACT } from "@/data/content";
import { Reveal, SectionHead } from "./Reveal";

export const Contact = () => (
  <section id="kapcsolat" className="relative py-28 sm:py-36" data-testid="contact-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <SectionHead eyebrow={CONTACT.eyebrow} title={CONTACT.title} testId="contact-head" />
      <Reveal delay={0.1} y={48}>
        <a
          href={`mailto:${CONTACT.email}`}
          data-testid="contact-email-card"
          className="card-glow group mt-14 flex flex-col gap-8 rounded-3xl border border-white/[0.08] bg-[#111113] p-8 sm:flex-row sm:items-center sm:justify-between sm:p-10"
        >
          <div className="flex items-center gap-5">
            <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl border border-white/10 bg-white/[0.04] text-white transition-colors duration-300 group-hover:border-[rgba(94,177,255,0.5)] group-hover:text-[var(--glow)]">
              <Mail size={22} />
            </span>
            <div>
              <p className="max-w-xl text-sm text-white/55">{CONTACT.text}</p>
              <p className="mt-2 font-display text-2xl font-bold text-white sm:text-3xl" data-testid="contact-email">{CONTACT.email}</p>
            </div>
          </div>
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-white/10 text-white/50 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:border-white/30 group-hover:text-white">
            <ArrowUpRight size={16} />
          </span>
        </a>
      </Reveal>
    </div>
  </section>
);
